import Fuse from 'fuse.js'

export default {
  install: (app, options = {}) => {
    // This creates the global this.$search function
    const searchFunction = (query, list, fuseOptions = {}) => {
      return new Promise((resolve) => {
        const fuse = new Fuse(list, fuseOptions);
        // Fuse.js returns a complex object; we just want the original items
        const results = fuse.search(query).map(result => result.item);
        resolve(results);
      });
    };
    app.config.globalProperties.$search = searchFunction;
  }
}
